import React from 'react';
import { Play, Pause, X, Volume2, Loader2 } from 'lucide-react';
import { useAudio } from '../contexts/AudioContext';
import { motion, AnimatePresence } from 'framer-motion';

const GlobalMiniPlayer = () => {
    const { isPlaying, isLoading, progress, currentText, stopAudio, togglePlayPause, source } = useAudio();

    // Only show if there's an active source (playing or loading)
    if (!source) return null;

    return (
        <AnimatePresence>
            <motion.div 
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 100, opacity: 0 }}
                drag
                dragMomentum={false}
                dragElastic={0.1}
                className="global-mini-player"
                style={{ touchAction: 'none' }}
            >
                <div className="player-content">
                    {/* Left: Icon/Status */}
                    <div className="player-left">
                        {isLoading ? (
                            <Loader2 className="animate-spin text-blue-500" size={20} />
                        ) : (
                            <Volume2 className={isPlaying ? "text-blue-500" : "text-gray-400"} size={20} />
                        )}
                    </div>

                    {/* Center: Progress & Text */}
                    <div className="player-center">
                        <div className="player-text-wrap">
                            <span className="player-source-tag">
                                {source === 'recommendation' ? 'Advisory' : 'Chatbot'}
                            </span>
                            <p className="player-text">{currentText}</p>
                        </div>
                        <div className="player-progress-container">
                            <div 
                                className="player-progress-bar" 
                                style={{ width: `${progress}%` }}
                            />
                        </div>
                    </div>

                    {/* Right: Controls */}
                    <div className="player-right">
                        <button 
                            onClick={togglePlayPause} 
                            className="player-control-btn"
                            disabled={isLoading}
                        >
                            {isPlaying ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" />}
                        </button>
                        <button onClick={stopAudio} className="player-close-btn">
                            <X size={20} />
                        </button>
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );
};

export default GlobalMiniPlayer;
